import { routes } from '../routes/registry'

// Standalone legal docs mirrored from the Slite workspace (they live under
// the help center root, so the scoped website API key can read them).
export const LEGAL_DOC_NOTE_IDS = {
  legalInformation: '9jKB19d_7cVNSi',
  privacy: 'H1mLnkz6~',
  security: 'S1TSuHnZf',
} as const

export type LegalDocKey = keyof typeof LEGAL_DOC_NOTE_IDS

export const LEGAL_DOC_PATHS: Record<LegalDocKey, string> = {
  legalInformation: routes.legal.legalInformation.path,
  privacy: routes.legal.privacy.path,
  security: routes.legal.security.path,
}

export function legalDocKeyForPath(path: string): LegalDocKey | null {
  const entry = Object.entries(LEGAL_DOC_PATHS).find(
    ([, docPath]) => docPath === path
  )
  return entry ? (entry[0] as LegalDocKey) : null
}

export function legalDocPathForNoteId(noteId: string): string | null {
  const entry = Object.entries(LEGAL_DOC_NOTE_IDS).find(
    ([, id]) => id === noteId
  )
  return entry ? LEGAL_DOC_PATHS[entry[0] as LegalDocKey] : null
}
